import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { retrievePageMenu } from "../../../redux/slice/page-menu.slice";
import { RootState, useAppDispatch } from "../../../redux/store";

interface Props {
  isProhibited: boolean;
}

const Header404Component = (props: Props) => {
  const { isProhibited } = props;

  const path = isProhibited ? "%2FLogin%2FProhibited" : "%2F404";

  const { RapsEuropeData } = useSelector((state: RootState) => state.rapsEurope);
  const [description, setDescription] = useState("");

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(retrievePageMenu(path));
  }, []);

  useEffect(() => {
    if (RapsEuropeData[0]) {
      let rapsResult = RapsEuropeData[0].result && RapsEuropeData[0].result[0];
      if (rapsResult) {
        setDescription(rapsResult.description);
      }
    }
  }, [RapsEuropeData]);

  return <>{description !== "" && <div className="container-fluid" dangerouslySetInnerHTML={{ __html: description }}></div>}</>;
};

export default Header404Component;
